import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { TermSeparator } from './separators';
export var TextFieldFilterOperationType = /*#__PURE__*/ function(TextFieldFilterOperationType) {
    TextFieldFilterOperationType["Contains"] = "Contains";
    TextFieldFilterOperationType["DoesNotContain"] = "DoesNotContain";
    TextFieldFilterOperationType["IsEmpty"] = "IsEmpty";
    TextFieldFilterOperationType["IsNotEmpty"] = "IsNotEmpty";
    TextFieldFilterOperationType["IsExactly"] = "IsExactly";
    TextFieldFilterOperationType["IsNotExactly"] = "IsNotExactly";
    return TextFieldFilterOperationType;
}({});
export const TextFieldFilterOperationTypes = [
    "Contains",
    "DoesNotContain",
    "IsEmpty",
    "IsNotEmpty"
];
export const TextFieldFilterOperationTypesWithExact = [
    "Contains",
    "DoesNotContain",
    "IsEmpty",
    "IsNotEmpty",
    "IsExactly",
    "IsNotExactly"
];
export const TextOptions = (field)=>TextFieldFilterOperationTypesWithExact.map((type)=>({
            field,
            type
        }));
export const TextFieldFilterOperationTypesWithValue = [
    "Contains",
    "DoesNotContain"
];
export const isOptional = (type)=>type === "IsEmpty" || type === "IsNotEmpty";
const isValid = (filter)=>{
    switch(filter.type){
        case "Contains":
        case "DoesNotContain":
        case "IsExactly":
        case "IsNotExactly":
            return filter.value != null && filter.value.trim().length > 0;
        default:
            return true;
    }
};
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case "IsEmpty":
        case "IsNotEmpty":
            return type;
        case "Contains":
        case "DoesNotContain":
        case "IsExactly":
        case "IsNotExactly":
            return [
                type,
                filter.value == null ? 'null' : filter.value
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case "IsEmpty":
        case "IsNotEmpty":
            return {
                field,
                type
            };
        case "Contains":
        case "DoesNotContain":
        case "IsExactly":
        case "IsNotExactly":
            {
                // Attempt the legacy JSON-string decode first (for any historical URL
                // that relied on it), and fall back to the raw meta when the synthetic
                // JSON is malformed (e.g. the value contains a literal `"`, `\`, or
                // control char). The old hard-fail behaviour silently dropped the whole
                // filter via the caller's try/catch — see `filter-transformer.tryParse`.
                let string;
                try {
                    string = JSON.parse(`"${meta}"`);
                } catch (unused) {
                    string = meta !== null && meta !== void 0 ? meta : null;
                }
                return {
                    field,
                    type,
                    value: string == null ? undefined : string
                };
            }
        default:
            return unreachable(type);
    }
};
export const TextFieldFilter = {
    isValid,
    toString,
    parse
};
export const doesTextFilterHaveValue = (arg)=>[
        "Contains",
        "DoesNotContain"
    ].includes(arg.type);
